var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-image',{class:_vm.load ? null : 'full-width',attrs:{"src":_vm.src},on:{"load":_vm.handleImgLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }